import React, { memo, useEffect } from "react";
import { getDailyAvailabilities } from "../../requests/daily_availabilities.requests";
import { DailyLightInfoResponse } from "../../types";
import { useErrorHandler } from "react-error-boundary";
import calendarService from "../../services/calendar-service";
import styled from "styled-components";
import { Loader } from "../loader/loader";
import { selectionStoreChangesService } from "../../services/selection-store-changes.service";
import { GolEventListener } from "./calendar";

const LoaderWrapper = styled.div`
  position: relative;
  min-width: 100px;
  min-height: 100px;
`;

const DailyAvailabilitiesFetcher = () => {
  const throwError = useErrorHandler();
  useEffect(() => {
    const subscription = getDailyAvailabilities().subscribe(
      (dailyLightInfoResponseData: DailyLightInfoResponse) => {
        calendarService.setupServiceData(dailyLightInfoResponseData);
        selectionStoreChangesService.dispatch(GolEventListener.OnComplete);
      },
      throwError
    );

    return () => {
      subscription.unsubscribe();
    };
  }, [throwError]);

  return (
    <LoaderWrapper>
      <Loader />
    </LoaderWrapper>
  );
};

export default memo(DailyAvailabilitiesFetcher);
